module.exports = __webpack_public_path__ + "static/media/clarinet.daf3162f.svg";